import axios from "axios";
import env from "../variables/EndpointEnvironment";

const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}

const KoreanLinkAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-masa-depan-anda/korean-link${props}`,
    {
      headers
    }
  );
};

export default KoreanLinkAPI;
